import type { ButtonProps } from '@/app/components/button';
import type { ImageProps } from '@/app/components/media/image/types';
import { getMyIsuzuStore, MY_ISUZU_APP_STORE_URLS } from '@/app/utils/my-isuzu';

type ImagePropsType = Omit<ImageProps, 'aspectRatio'>;
export interface DealerHomeData {
  coverImage: {
    image: ImagePropsType;
    imageDesktop: ImagePropsType;
  };
}

export interface StoreAppProps {
  qrcode?: {
    url: string;
    image?: ImagePropsType;
  };
  ios?: {
    url: string;
    image?: ImagePropsType;
  };
  android?: {
    url: string;
    image?: ImagePropsType;
  };
}

export interface DealerPopupData {
  isActive: boolean;
  description: string;
  logo?: ImagePropsType;
  coverImage: ImagePropsType;
  button: ButtonProps;
  storeApp?: StoreAppProps;
}

export const DEALER_PLACEHOLDER_SEARCH = 'ค้นหาจังหวัด, เขต หรือ เลขไปรษณีย์';

export const DEALER_HOME_DATA: DealerHomeData = {
  coverImage: {
    image: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt38a932f67a301b42/681c2d1037907f5b235fe286/service-center.jpg',
      alt: 'Service Center',
      width: 1080,
      height: 608,
    },
    imageDesktop: {
      src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt68206a22eb45c1bd/681c2d0f478db2d4f275a8de/service-center-desktop.jpg',
      alt: 'Service Center',
      width: 1080,
      height: 1440,
    },
  },
};

export const DEALER_POPUP_DATA: DealerPopupData = {
  isActive: false,
  description: `นัดหมายบริการ บน my-ISUZU App <br /><strong>ครั้งแรกรับส่วนลดสูงสุด 100 บาท</strong>`,
  button: {
    children: 'นัดหมายเลย',
    href: 'https://www.isuzu-tis.com/privileges/my-isuzu', // TO-DO
    target: '_blank',
  },
  logo: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb0d4ad1c2bafd770/681bf6870dc84fbfbb85c48d/logo.svg',
    alt: 'My Isuzu',
    width: 160,
    height: 20,
  },
  coverImage: {
    // NOTE: permanent link
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt94daad87dee96e7e/cover-image.jpg',
    alt: 'Ads',
    width: 328,
    height: 185,
  },
  storeApp: {
    qrcode: {
      url: getMyIsuzuStore(),
      image: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blte44306f61a195a3e/62f8a357361754115f1ea149/qr-code.png',
        alt: 'QR Code my-ISUZU',
        width: 96,
        height: 96,
      },
    },
    ios: {
      url: MY_ISUZU_APP_STORE_URLS.IOS,
      image: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltd46cf7bc6a85fa84/63030819509e321033a88c1b/app-store.svg',
        alt: 'Download on the App Store',
        width: 174,
        height: 64,
      },
    },
    android: {
      url: MY_ISUZU_APP_STORE_URLS.ANDROID,
      image: {
        src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/blt9aee4595cad09239/63030833d5efbe63363b7124/google-play.svg',
        alt: 'Get it On Google Play',
        width: 174,
        height: 64,
      },
    },
  },
};
